<form #form="ngForm" autocomplete="off" class="app-grid">
    <mat-form-field class="columns-12">
        <mat-label>{{ 'components.forms.kanban.columnName' | appTranslate }}</mat-label>
        <input type="text" required matInput #column="ngModel" name="column" [(ngModel)]="columnName" />
        <mat-error *ngIf="column.invalid">{{ column.errors | formErrors }}</mat-error>
    </mat-form-field>
</form>
